import type { ApiClient, RequestStatus } from '../api/client'
import { t } from '../i18n/dict'

/**
 * The trader's write channel, as the TUI does it: submit a queue row, watch its status. The
 * daemon on the box does the actual work; the plugin holds nothing. Sixty seconds is the same
 * patience the console has — a request that outlives it is reported as "the guardian is not
 * processing requests", never silently dropped.
 */
export async function awaitRequest(
  api: ApiClient,
  id: number,
  onStatus?: (status: RequestStatus) => void,
  timeoutMs = 60_000,
  intervalMs = 750,
): Promise<RequestStatus> {
  const deadline = Date.now() + timeoutMs
  while (Date.now() < deadline) {
    await new Promise((resolve) => setTimeout(resolve, intervalMs))
    const status = await api.request(id)
    onStatus?.(status)
    if (status.status === 'done' || status.status === 'failed') return status
  }
  return {
    id,
    kind: '',
    status: 'failed',
    result: null,
    error: t('requests.timeout'),
  }
}
